var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Bitecs, Component, BitecsSchema, type } from "./decorators/type.js";
import { registerSchema } from "./components/ComponentRegistry.js";
import "./components/types.js";
import { C as ComponentCategory } from "./enums-86f58524.js";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let RadiusSchema = class extends BitecsSchema {
  constructor() {
    super(...arguments);
    __publicField(this, "_radius");
  }
  static get radius() {
    return RadiusSchema.store.radius[this.id];
  }
  static set radius(value) {
    RadiusSchema.store.radius[this.id] = value;
    RadiusSchema.store.__changes[this.id] |= 1;
  }
};
__decorateClass([
  type("uint16")
], RadiusSchema.prototype, "_radius", 2);
RadiusSchema = __decorateClass([
  Bitecs(),
  Component("Radius")
], RadiusSchema);
registerSchema(ComponentCategory.BEHAVIOR, RadiusSchema);
const __vite_glob_0_16 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get RadiusSchema() {
    return RadiusSchema;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  RadiusSchema as R,
  __vite_glob_0_16 as _
};
//# sourceMappingURL=Radius-89a665f8.js.map
